import { Component, inject } from '@angular/core';
import { EquationVariableGroupService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  EquationVariableGroupCreateDto,
  EquationVariableGroupDto,
  EquationVariableGroupExcelDownloadDto,
  EquationVariableGroupUpdateDto,
} from '../proxy/general/dtos/equation-variable-group';
import { EQUATIONVARIABLEGROUP_CONFIG, EQUATIONVARIABLEGROUP_FIELDS } from './equation-variable-group.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-equation-variable-group',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, EquationVariableGroupService, ConfirmationService],
  templateUrl: './equation-variable-group.html',
  styleUrl: './equation-variable-group.scss',
})
export class EquationVariableGroup extends BaseCrudComponent<
  EquationVariableGroupDto,
  EquationVariableGroupCreateDto,
  EquationVariableGroupUpdateDto,
  EquationVariableGroupExcelDownloadDto
> {
  service = inject(EquationVariableGroupService);
  config = EQUATIONVARIABLEGROUP_CONFIG;
  fields = EQUATIONVARIABLEGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: EquationVariableGroupDto): EquationVariableGroupUpdateDto {
    return {
      description: data.description,
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'EquationVariableGroup';
  }
}
